/// Returns the date in format YYYY-MM-DD
export const getDate = (date: Date) => date.toISOString().split("T")[0];
